import React, {useState, useRef, useEffect} from 'react';
import './index.css';
import TabSection from '../../components/tabsection/index';
import {Field, Form, Formik, FieldArray} from 'formik';
import {Trans, useTranslation} from 'react-i18next';
import {history} from '../../../../utils/redux/store';
import RadioButton from '../../../../components/formik/RadioButton';
import ColorField from '../../../../components/product/color/colorfield';
import SelectBox from '../../../../components/formik/SelectBox';
import skinResultPageStyle from '../../../../utils/config/skinResultPageStyle';
import _get from 'lodash/get';
import ImageField from '../../../../components/formik/ImageField';
import InputBox from '../../../../components/formik/InputBox';
import {toast} from 'react-toastify';
import _isEmpty from 'lodash/isEmpty';
import Select from 'react-select';
import DraftEditor from '../../../../components/formik/DraftEditor';
import Header from '../../components/header';
import PreviewModule from '../../components/previewmodule';
import ButtonWithRestoreGroup from '../../../../components/formik/ButtonWithRestoreGroup';
import {useSelector} from 'react-redux';
import DeviceImage from './deviceImage';
import {
  handleImage,
  getBrandId,
  zipGenerate,
  getTemplateDefaultConfig,
  getTemplateLayout,
  getTemplate,
  updateTemplate,
} from '../../../../utils/skincareUtils';
import smbUtils from '../../../../utils/smbUtils';
import templateConfigs from '../config/utils/templateUtils';
import Loader from '../../../../components/spinner/Loader';
import UnSavedModal from '../../components/unSavedModal';
import useWindowWidth from '../../../../components/hook/useWindowWidth';
import classnames from 'classnames';
import cookieUtils from '../../../../utils/cookieUtils';
import PublishToOnlineModal from '../components/PublishToOnlineModal';
import {privilegeUtils} from '../../../../utils/privilegeUtils';
import langUtils from '../../../../utils/langUtils';
import {deviceOptionsWithOutPadLandscape} from '../config/utils/optionsUtils';

export default function LandingPage() {
  const width = useWindowWidth();
  const auth = useSelector(state => state.components.auth.accountSummary);
  const {token, customerId, brandInfo} = smbUtils.customerInfo(auth);
  const {t} = useTranslation();
  const [isLoaded, setIsLoaded] = useState(true);
  const [previewUrl, setPreviewUrl] = useState('');
  const [template, setTemplate] = useState();
  const [publishStatus, setPublishStatus] = useState(false);
  const [isShowPublishModal, setIsShowPublishModal] = useState(false);
  const [theme, setTheme] = useState('');
  const [showDialog, setShowDialog] = useState(false);
  const [lightData, setLightData] = useState();
  const [darkData, setDarkData] = useState();
  const [isFirst, setIsFirst] = useState(true);
  const [hidePreview, setHidePreview] = useState(false);
  const [language, setLanguage] = useState(
    langUtils
      .getAppLangList()
      .find(l => l.value === cookieUtils.getCookie('appLang')) || {
      label: 'English',
      value: 'enu',
    }
  );
  const [initValue, setInitValue] = useState({
    templateStyle: 'light',
    templateType: 'skincare',
    languageType: 'enu',
    pageType: 'landing',
    header: {
      settingButton: {
        image: '',
      },
      logo: {
        image: '',
      },
    },
    body: {
      backgroundColor: '#ffffff',
      banners: [
        {
          deviceType: 'pad',
          images: ['', '', ''],
          autoplayTimeout: 60,
        },
        {
          deviceType: 'mobile',
          images: ['', '', ''],
          autoplayTimeout: 60,
        },
      ],
    },
    footer: {
      buttons: [
        {
          type: 'skinAnalysis',
          text: '',
          textI18n: {
            enu: 'Skin Analysis',
            fra: 'Analyse de la peau',
            jpn: '肌分析',
            kor: '피부 분석',
            deu: 'Hautanalyse',
            esp: 'Análisis de piel',
            ita: 'Analisi pelle',
          },
          backgroundColor: '#ffffff',
          border: {
            width: '1px',
            style: 'solid',
            color: '#ffffff',
            radius: '18px',
          },
        },
      ],
    },
  });
  const [revisionId, setRevisionId] = useState();
  const [templateId, setTemplateId] = useState('');

  useEffect(() => {
    if (_get(brandInfo, 'templateVersion') === 2) {
      history.push('/skincare-pro/ui-configuration/landing');
    }
    getBrandId(token, customerId).then(res => {
      if (res && _get(res, 'landingPageRvId', '')) {
        setRevisionId(_get(res, 'landingPageRvId', ''));
      }
    });
  }, []);

  const handleRestore = mode => {
    getTemplateDefaultConfig(
      'SmbLandingPage',
      mode.replace(mode[0], mode[0].toUpperCase()),
      1,
      customerId
    ).then(r => {
      if (r && r.templateMetadata && r.fileId) {
        let data = r.templateMetadata;
        setTemplate(data);
        setInitValue(data);
        updateTemplate(
          token,
          customerId,
          templateId,
          'LandingPage',
          data,
          r.fileId
        ).then(r => {
          setPublishStatus(!publishStatus);
          toast.success(
            <Trans i18nKey="c.f.simple.button.group.success">success</Trans>
          );
        });
      }
    });
  };

  useEffect(() => {
    if (revisionId) {
      getTemplateLayout(
        token,
        customerId,
        'SmbLandingPage',
        _get(brandInfo, 'templateVersion')
      ).then(res => {
        if (res) {
          setPreviewUrl(res.indexPage);
        }
      });

      getTemplate(token, customerId, revisionId, 'LandingPage')
        .then(res => {
          if (res && res.metaDataJson) {
            let data = JSON.parse(res.metaDataJson);
            setTemplate(JSON.parse(res.metaDataJson));
            setTheme(data.templateStyle);
            setInitValue({
              ...data,
            });
          }
          setTemplateId(_get(res, 'templateId', ''));
        })
        .then(() => setIsLoaded(false));
    }
  }, [revisionId]);

  const getInitValue = values => {
    return {
      ...values,
      body: {
        ...values.body,
        banners: [
          {
            ...values.body.banners[0],
            images: [
              {url: values.body.banners[0].images[0]},
              {url: values.body.banners[0].images[1]},
              {url: values.body.banners[0].images[2]},
            ],
          },
          {
            ...values.body.banners[1],
            images: [
              {url: values.body.banners[1].images[0]},
              {url: values.body.banners[1].images[1]},
              {url: values.body.banners[1].images[2]},
            ],
          },
        ],
      },
      footer: {
        buttons: [
          {
            ...values.footer.buttons[0],
            border: {
              ..._get(values.footer.buttons[0], 'border'),
              radius: _get(values.footer.buttons[0], 'border.radius', '').match(
                /\d+/
              ),
            },
          },
        ],
      },
    };
  };

  const [device, setDevice] = useState({
    label: (
      <Trans i18nKey="p.s.u.c.preview.device.pad.portrait">
        iPad - Portrait
      </Trans>
    ),
    value: 'pad',
  });
  const formRef = useRef();
  const formikConfig = {
    enableReinitialize: true,
    initialValues: getInitValue(initValue),
    onSubmit: async (values, {setSubmitting, resetForm}) => {
      setSubmitting(true);
      async function ImageToUrl(name) {
        if (_get(values, `${name}.image`)) {
          return await handleImage(
            _get(values, `${name}.image`),
            token,
            customerId
          );
        } else if (_get(values, `${name}.url`)) {
          return await _get(values, `${name}.url`);
        } else if (smbUtils.isUrl(_get(values, `${name}`))) {
          return await _get(values, `${name}`);
        }
        return '';
      }
      const data = {
        ...values,
        header: {
          settingButton: {
            image: await handleImage(
              _get(values, 'header.settingButton.url') ||
                _get(values, 'header.settingButton.image'),
              token,
              customerId
            ),
          },
          logo: {
            image: await handleImage(
              _get(values, 'header.logo.url') ||
                _get(values, 'header.logo.image'),
              token,
              customerId
            ),
          },
        },
        body: {
          ...values.body,
          banners: [
            {
              ...values.body.banners[0],
              images: [
                await ImageToUrl('body.banners[0].images[0]'),
                await ImageToUrl('body.banners[0].images[1]'),
                await ImageToUrl('body.banners[0].images[2]'),
              ],
            },
            {
              ...values.body.banners[1],
              images: [
                await ImageToUrl('body.banners[1].images[0]'),
                await ImageToUrl('body.banners[1].images[1]'),
                await ImageToUrl('body.banners[1].images[2]'),
              ],
            },
          ],
        },
        footer: {
          buttons: [
            {
              ...values.footer.buttons[0],
              border: {
                ...values.footer.buttons[0].border,
                radius: values.footer.buttons[0].border.radius + 'px',
              },
            },
          ],
        },
      };

      const fileId = await zipGenerate(
        await templateConfigs.toLandingZip(data),
        'LandingPage',
        token,
        customerId,
        [
          {
            fileName: 'header.jpg',
            file: data.header.settingButton.image,
          },
          {
            fileName: 'logo.jpg',
            file: data.header.logo.image,
          },
          {
            fileName: 'banner_pad_1.jpg',
            file: data.body.banners[0].images[0],
          },
          {
            fileName: 'banner_pad_2.jpg',
            file: data.body.banners[0].images[1],
          },
          {
            fileName: 'banner_pad_3.jpg',
            file: data.body.banners[0].images[2],
          },
          {
            fileName: 'banner_mobile_1.jpg',
            file: data.body.banners[1].images[0],
          },
          {
            fileName: 'banner_mobile_2.jpg',
            file: data.body.banners[1].images[1],
          },
          {
            fileName: 'banner_mobile_3.jpg',
            file: data.body.banners[1].images[2],
          },
        ]
      );

      await updateTemplate(
        token,
        customerId,
        templateId,
        'LandingPage',
        data,
        fileId
      )
        .then(r => setIsShowPublishModal(true))
        .catch(r => {
          toast.error(
            <Trans i18nKey="c.f.simple.button.group.failed">failed</Trans>
          );
          setSubmitting(false);
        });
    },
  };

  const handleOnChange = () => {
    if (!formRef.current) {
      return;
    }
    const formData = formRef.current.state.values;
    const style = _get(formData, 'templateStyle');
    if (style && style !== theme) {
      if (isFirst) {
        if (style === 'dark') {
          setLightData(formData);
        } else {
          setDarkData(formData);
        }
        setDefault(style);
        setTheme(style);
        setIsFirst(false);
      } else {
        setTheme(style);
        setShowDialog(true);
      }
    }
  };

  const changeTheme = (style, value, setValues, setFieldValue) => {
    setHidePreview(true);
    if (style === 'dark') {
      setLightData(value);
      if (darkData) {
        setValues(darkData);
        setFieldValue('templateStyle', style);
        setShowDialog(false);
      } else {
        setDefault(style);
      }
    } else {
      setDarkData(value);
      if (lightData) {
        setValues(lightData);
        setFieldValue('templateStyle', style);
        setShowDialog(false);
      } else {
        setDefault(style);
      }
    }
    setTimeout(() => {
      setHidePreview(false);
    }, 200);
  };

  const setDefault = style => {
    setHidePreview(true);
    getTemplateDefaultConfig(
      'SmbLandingPage',
      style.replace(style[0], style[0].toUpperCase()),
      1,
      customerId
    ).then(r => {
      if (r && r.templateMetadata) {
        let data = r.templateMetadata;
        setTemplate(data);
        setInitValue({
          ...data,
          //remember to delete
          footer: {
            buttons: [
              {
                ..._get(data, 'footer.buttons[0]'),
                textI18n: _get(data, 'footer.buttons[0].textI18n')
                  ? _get(data, 'footer.buttons[0].textI18n')
                  : {
                      enu: 'Skin Analysis',
                      fra: 'Analyse de la peau',
                      jpn: '肌分析',
                      kor: '피부 분석',
                      deu: 'Hautanalyse',
                      esp: 'Análisis de piel',
                      ita: 'Analisi pelle',
                    },
              },
            ],
          },
        });
        setShowDialog(false);
        setTimeout(() => {
          setHidePreview(false);
        }, 200);
      }
    });
  };

  if (
    !(
      privilegeUtils.canUiConfig(auth) ||
      privilegeUtils.isTechnicalSupport(auth)
    )
  ) {
    history.push('/');
  }

  return isLoaded ? (
    <div>
      <Header />
      <Loader />
    </div>
  ) : (
    <Formik {...formikConfig} ref={formRef}>
      {formikProps => (
        <Form
          className="skincare-configuration-form"
          onChange={() => {
            setTimeout(() => {
              handleOnChange();
            });
          }}
        >
          <Header publishStatus={publishStatus} dirty={formikProps.dirty} />
          <div
            className="skincare-configuration-layout"
            style={{height: 'calc(100% - 170px)'}}
          >
            <div className="skincare-configuration-layout__left">
              {formikProps && formikProps.dirty !== null && (
                <TabSection dirty={formikProps.dirty} />
              )}

              <div className="kt-portlet skincare-configuration-layout__left-portlet">
                <div className="kt-portlet__body skincare-configuration-layout__left-portlet__body">
                  <div>
                    <h5>
                      <Trans i18nKey="p.s.uiconfiguration.skinresultpage.landingpage.theme">
                        Landing Page Theme
                      </Trans>
                      <div
                        className="kt-margin-t-10"
                        style={{
                          backgroundColor: '#e1e1ef',
                          height: '1px',
                        }}
                      />
                    </h5>
                    <div className="form-group row">
                      {width >= 1366 && (
                        <label className="col-3 col-form-label text-left" />
                      )}
                      <div
                        className={classnames({
                          'col-6': width < 1366,
                          'col-3': width >= 1366,
                        })}
                      >
                        <Field
                          name={'templateStyle'}
                          label={
                            <Trans i18nKey="p.s.uiconfiguration.skinresultpage.template.light">
                              Light
                            </Trans>
                          }
                          value={'light'}
                          component={RadioButton}
                        />
                        <img
                          src={require('../../../../assets/images/skincare/skincarepro_v1_2landing.png')}
                          alt={''}
                          width={'inherit'}
                          style={{width: '90%', boxShadow: '0 0 5px'}}
                        />
                      </div>
                      <div
                        className={classnames({
                          'col-6': width < 1366,
                          'col-3': width >= 1366,
                        })}
                      >
                        <Field
                          name={'templateStyle'}
                          label={
                            <Trans i18nKey="p.s.uiconfiguration.skinresultpage.template.dark">
                              Dark
                            </Trans>
                          }
                          value={'dark'}
                          component={RadioButton}
                        />
                        <img
                          src={require('../../../../assets/images/skincare/skincarepro_v1_dk_1landing.png')}
                          alt={''}
                          style={{width: '90%', boxShadow: '0 0 5px'}}
                        />
                      </div>
                    </div>
                    <h5>
                      <Trans i18nKey="p.s.uiconfiguration.landing.page.header">
                        Page Header
                      </Trans>
                      <div
                        className="kt-margin-t-10"
                        style={{
                          backgroundColor: '#e1e1ef',
                          height: '1px',
                        }}
                      />
                    </h5>
                    <div className="form-group row">
                      <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                        <Trans i18nKey="p.s.uiconfiguration.landingpage.header.image">
                          Header Image
                        </Trans>
                      </label>
                      <div className="col-4 col-lg-4 col-md-4">
                        <Field
                          name="header.logo.url"
                          imageUrl={_get(
                            formikProps.values,
                            'header.logo.image'
                          )}
                          scaleImage={true}
                          clearFormFields={[
                            'header.logo.url',
                            'header.logo.image',
                          ]}
                          component={ImageField}
                          width={540}
                          height={145}
                          maxWidth={width > 1024 ? 540 : 270}
                          maxHeight={width > 1024 ? 145 : 72.5}
                        />
                      </div>
                    </div>
                    <div className="form-group row sm-desc">
                      <label className="col-3  col-lg-4 col-md-4 col-form-label text-right">
                        <Trans i18nKey="p.s.uiconfiguration.landingpage.setting.icon">
                          Setting icon
                        </Trans>
                      </label>
                      <div className="col-4">
                        <Field
                          name="header.settingButton.url"
                          imageUrl={_get(
                            formikProps.values,
                            'header.settingButton.image'
                          )}
                          scaleImage={true}
                          clearFormFields={[
                            'header.settingButton.url',
                            'header.settingButton.image',
                          ]}
                          component={ImageField}
                          width={200}
                          height={200}
                          maxWidth={width > 1024 ? 300 : 150}
                          maxHeight={width > 1024 ? 300 : 150}
                        />
                      </div>
                    </div>
                  </div>
                  <h5>
                    <Trans i18nKey="p.s.uiconfiguration.landing.header.color">
                      Header Color
                    </Trans>
                    <div
                      className="kt-margin-t-10"
                      style={{
                        backgroundColor: '#e1e1ef',
                        height: '1px',
                      }}
                    />
                  </h5>
                  <div className="form-group row">
                    <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                      <Trans i18nKey="p.s.uiconfiguration.skinresultpage.background.color">
                        Background Color
                      </Trans>
                    </label>
                    <div
                      className={classnames({
                        'col-8': width < 1366,
                        'col-4': width >= 1366,
                      })}
                    >
                      <Field
                        name="body.backgroundColor"
                        component={ColorField}
                      />
                    </div>
                  </div>
                  <h5>
                    <Trans i18nKey="p.s.uiconfiguration.landingpage.skin.main">
                      Main
                    </Trans>
                    <div
                      className="kt-margin-t-10"
                      style={{
                        backgroundColor: '#e1e1ef',
                        height: '1px',
                      }}
                    />
                  </h5>
                  <h6 className="kt-margin-t-10">
                    <Trans i18nKey="p.s.uiconfiguration.landingpage.main.image">
                      Main Image
                    </Trans>
                  </h6>
                  <div className="form-group row">
                    <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                      <Trans i18nKey="p.s.uiconfiguration.landingpage.device">
                        Device
                      </Trans>
                    </label>
                    <div className="col-4">
                      <Select
                        options={deviceOptionsWithOutPadLandscape}
                        onChange={o => {
                          setDevice(o);
                        }}
                        value={device}
                        isSearchable={false}
                        isClearable={false}
                        placeholder={
                          <Trans i18nKey="c.c.select.placeholder">
                            Select...
                          </Trans>
                        }
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                      <Trans i18nKey="p.s.uiconfiguration.landingpage.main.image">
                        Main Image
                      </Trans>
                    </label>
                    <div className="col-4">
                      {device.value === 'pad' && (
                        <FieldArray name={`body.banners[0].images`}>
                          {arrayHelpers => (
                            <div style={{display: 'flex'}}>
                              {!_isEmpty(
                                _get(
                                  formikProps.values,
                                  `body.banners[0].images`
                                )
                              ) &&
                                _get(
                                  formikProps.values,
                                  `body.banners[0].images`
                                ).map((s, index) => (
                                  <div
                                    key={`bodybanner${index}`}
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                    }}
                                  >
                                    {index !== 0 && (
                                      <button
                                        type="button"
                                        className="btn-icon-only default"
                                        style={{
                                          width: '25px',
                                          height: '25px',
                                          color: '#666',
                                        }}
                                        key={'btn' + index}
                                        onClick={() => {
                                          arrayHelpers.swap(index - 1, index);
                                        }}
                                      >
                                        <i className="fa fa-exchange-alt" />
                                      </button>
                                    )}
                                    <Field
                                      name={`body.banners[0].images[${index}]`}
                                      scaleImage={true}
                                      clearFormFields={['image', 'url']}
                                      component={DeviceImage}
                                      width={1536}
                                      height={1468}
                                      maxWidth={300}
                                      maxHeight={(300 / 1536) * 1468}
                                      values={formikProps.values}
                                    />
                                  </div>
                                ))}
                            </div>
                          )}
                        </FieldArray>
                      )}
                      {device.value === 'mobile' && (
                        <FieldArray name={`body.banners[1].images`}>
                          {arrayHelpers => (
                            <div style={{display: 'flex'}}>
                              {!_isEmpty(
                                _get(
                                  formikProps.values,
                                  `body.banners[1].images`
                                )
                              ) &&
                                _get(
                                  formikProps.values,
                                  `body.banners[1].images`
                                ).map((s, index) => (
                                  <div
                                    key={`bodympbilebanner${index}`}
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                    }}
                                  >
                                    {index !== 0 && (
                                      <button
                                        type="button"
                                        className="btn-icon-only default"
                                        style={{
                                          width: '25px',
                                          height: '25px',
                                          color: '#666',
                                        }}
                                        key={'btn' + index}
                                        onClick={() => {
                                          arrayHelpers.swap(index - 1, index);
                                        }}
                                      >
                                        <i className="fa fa-exchange-alt" />
                                      </button>
                                    )}
                                    <Field
                                      name={`body.banners[1].images[${index}]`}
                                      scaleImage={true}
                                      clearFormFields={['image', 'url']}
                                      component={DeviceImage}
                                      width={750}
                                      height={996}
                                      maxWidth={300}
                                      maxHeight={(300 / 750) * 996}
                                      values={formikProps.values}
                                    />
                                  </div>
                                ))}
                            </div>
                          )}
                        </FieldArray>
                      )}
                    </div>
                  </div>
                  {device.value === 'pad' && (
                    <div className="form-group row">
                      <label className="col-3 col-lg-5 col-md-5 col-form-label text-right">
                        <Trans i18nKey="p.s.uiconfiguration.landingpage.speed.image.rollovers">
                          Speed of Image Rollovers
                        </Trans>
                      </label>
                      <div className={width >= 1366 ? 'col-3' : 'col-7'}>
                        <Field
                          name="body.banners[0].autoplayTimeout"
                          component={InputBox}
                          type="number"
                          postfix={
                            <Trans i18nKey="p.s.uiconfiguration.landingpage.speed.image.rollovers.seconds">
                              Seconds
                            </Trans>
                          }
                        />
                      </div>
                    </div>
                  )}
                  {device.value === 'mobile' && (
                    <div className="form-group row">
                      <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                        <Trans i18nKey="p.s.uiconfiguration.landingpage.speed.image.rollovers">
                          Speed of Image Rollovers
                        </Trans>
                      </label>
                      <div className={width >= 1366 ? 'col-3' : 'col-8'}>
                        <Field
                          name="body.banners[1].autoplayTimeout"
                          component={InputBox}
                          type="number"
                          postfix={
                            <Trans i18nKey="p.s.uiconfiguration.landingpage.speed.image.rollovers.seconds">
                              Seconds
                            </Trans>
                          }
                        />
                      </div>
                    </div>
                  )}
                  <h5>
                    <Trans i18nKey="p.s.uiconfiguration.landingpage.start.button">
                      Start Button
                    </Trans>
                    <div
                      className="kt-margin-t-10"
                      style={{
                        backgroundColor: '#e1e1ef',
                        height: '1px',
                      }}
                    />
                  </h5>
                  <h6 className="kt-margin-t-10">
                    <Trans i18nKey="p.s.uiconfiguration.landingpage.entry.button">
                      Entry Button
                    </Trans>
                  </h6>
                  <div
                    className="form-group row"
                    style={{alignItems: 'center'}}
                  >
                    <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                      <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.button.text">
                        Button Text
                      </Trans>
                    </label>
                    <div
                      className="col-9 col-lg-8 col-md-8 row"
                      style={{display: width >= 1366 ? 'flex' : 'block'}}
                    >
                      <div
                        className={classnames({
                          'col-3': width >= 1366,
                          'col-12': width < 1366,
                          'kt-margin-b-10': width <= 1366,
                        })}
                      >
                        <Select
                          options={langUtils.getAppLangList()}
                          onChange={o => {
                            setLanguage(o);
                          }}
                          value={language}
                          isSearchable={false}
                          isClearable={false}
                          placeholder={
                            <Trans i18nKey="c.c.select.placeholder">
                              Select...
                            </Trans>
                          }
                        />
                      </div>
                      <div
                        className={classnames({
                          'col-6': width >= 1366,
                          'col-12': width < 1366,
                          'kt-margin-b-10': width < 1366,
                        })}
                      >
                        <Field
                          name={`footer.buttons.[0].textI18n.${language.value}`}
                          id="description"
                          component={DraftEditor}
                          toolbarOnFocus={true}
                          containerStyle={{}}
                          editorClassname={'skin-res--editor'}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="form-group row"
                    style={{alignItems: 'center'}}
                  >
                    <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                      <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.button.background">
                        Button Background
                      </Trans>
                    </label>
                    <div className={width >= 1366 ? 'col-3' : 'col-8'}>
                      <Field
                        name="footer.buttons.[0].backgroundColor"
                        component={ColorField}
                      />
                    </div>
                  </div>
                  <div
                    className="form-group row"
                    style={{alignItems: 'center'}}
                  >
                    <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                      <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.button.border">
                        Button Border
                      </Trans>
                    </label>
                    <div
                      className="col-9 col-lg-8 col-md-8"
                      style={{display: width >= 1366 ? 'flex' : 'block'}}
                    >
                      <div
                        className={classnames({
                          'col-3': width >= 1366,
                          'col-9': width < 1366,
                          'kt-margin-b-20': width < 1366,
                        })}
                      >
                        <Field
                          component={ColorField}
                          name="footer.buttons.[0].border.color"
                        />
                      </div>
                      <div
                        className={classnames({
                          'col-3': width >= 1366,
                          'col-9': width < 1366,
                          'kt-margin-b-20': width < 1366,
                        })}
                      >
                        <Field
                          component={SelectBox}
                          options={skinResultPageStyle.getBorderWidthConfigs()}
                          name="footer.buttons.[0].border.width"
                        />
                      </div>
                      <div
                        className={classnames({
                          'col-3': width >= 1366,
                          'col-9': width < 1366,
                          'kt-margin-b-20': width < 1366,
                        })}
                      >
                        <Field
                          component={SelectBox}
                          options={skinResultPageStyle.getBorderStyleConfigs()}
                          name="footer.buttons.[0].border.style"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="form-group row"
                    style={{alignItems: 'center'}}
                  >
                    <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                      <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.button.radius">
                        Button Corner Radius
                      </Trans>
                    </label>
                    <div className={width >= 1366 ? 'col-3' : 'col-8'}>
                      <Field
                        name="footer.buttons.[0].border.radius"
                        component={InputBox}
                        type="number"
                        postfix={'px'}
                      />
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-end kt-margin-t-20">
                  <ButtonWithRestoreGroup
                    saveDirty={formikProps.dirty}
                    discardButton={false}
                    isUpdating={true}
                    onRestoreClick={() => {
                      handleRestore(_get(formikProps.values, 'templateStyle'));
                      formikProps.resetForm();
                    }}
                  />
                </div>
              </div>
            </div>
            {!isLoaded && !hidePreview && formikProps.values && (
              <div className="skincare-configuration-layout__right">
                <PreviewModule
                  values={formikProps.values}
                  template={{
                    ...formikProps.values,
                    header: {
                      settingButton: {
                        image:
                          _get(
                            formikProps.values,
                            'header.settingButton.url'
                          ) ||
                          _get(
                            formikProps.values,
                            'header.settingButton.image',
                            ''
                          ),
                      },
                      logo: {
                        image:
                          _get(formikProps.values, 'header.logo.url') ||
                          _get(formikProps.values, 'header.logo.image', ''),
                      },
                    },
                    body: {
                      ...formikProps.values.body,
                      banners: [
                        {
                          ...formikProps.values.body.banners[0],
                          images: [
                            _get(
                              formikProps.values,
                              'body.banners[0].images[0].image'
                            ) ||
                              _get(
                                formikProps.values,
                                'body.banners[0].images[0].url'
                              ),
                            _get(
                              formikProps.values,
                              'body.banners[0].images[1].image'
                            ) ||
                              _get(
                                formikProps.values,
                                'body.banners[0].images[1].url'
                              ),
                            _get(
                              formikProps.values,
                              'body.banners[0].images[2].image'
                            ) ||
                              _get(
                                formikProps.values,
                                'body.banners[0].images[2].url'
                              ),
                          ],
                        },
                        {
                          ...formikProps.values.body.banners[1],
                          images: [
                            _get(
                              formikProps.values,
                              'body.banners[1].images[0].image'
                            ) ||
                              _get(
                                formikProps.values,
                                'body.banners[1].images[0].url'
                              ),
                            _get(
                              formikProps.values,
                              'body.banners[1].images[1].image'
                            ) ||
                              _get(
                                formikProps.values,
                                'body.banners[1].images[1].url'
                              ),
                            _get(
                              formikProps.values,
                              'body.banners[1].images[2].image'
                            ) ||
                              _get(
                                formikProps.values,
                                'body.banners[1].images[2].url'
                              ),
                          ],
                        },
                      ],
                    },
                    footer: {
                      buttons: [
                        {
                          ...formikProps.values.footer.buttons[0],
                          border: {
                            ...formikProps.values.footer.buttons[0].border,
                            radius:
                              formikProps.values.footer.buttons[0].border
                                .radius + 'px',
                          },
                        },
                      ],
                    },
                  }}
                  previewUrl={previewUrl}
                  lang={language}
                  type="LandingPage"
                  onChangeLanguage={lang => {
                    setLanguage(lang);
                  }}
                  isV2Above={false}
                />
              </div>
            )}
            <UnSavedModal
              type={'theme'}
              showModal={showDialog}
              setShowModal={setShowDialog}
              handleLeave={() =>
                changeTheme(
                  theme,
                  formikProps.values,
                  formikProps.setValues,
                  formikProps.setFieldValue
                )
              }
              handleCancel={() => {
                formikProps.setFieldValue(
                  'templateStyle',
                  theme === 'dark' ? 'light' : 'dark'
                );
                setTheme(theme => (theme === 'dark' ? 'light' : 'dark'));
              }}
            />
            <PublishToOnlineModal
              isShow={isShowPublishModal}
              onPublish={isPublish => {
                formikProps.setSubmitting(false);
                formikProps.resetForm(formikProps.values);
                setPublishStatus(isPublish);
                setIsShowPublishModal(false);
              }}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
}
